import { emailManagerConstants } from '../constants/emailManagerConstants';
 
const initialState = {
    sending: false,
    emailList:{},
    cityList:{},
    emailStatus:{},
    emailUpdateStatus:{},
    emailData:{},
    deleteStatus:{},
    testMailStatus:{},
    dealList:{},
    template:{},
    error:{},
    exportStatus:{},
    importStatus:{},
    subscriberList:{},
    disableStatus:{},
    totalUsers:{},
    notification: {},
    notDetail: {},
    status: {},
    marketResponse:{},
    marketList: {},
    marketDetail: {}
};

export default function emailMangerReducer(state= initialState, action) {
  switch (action.type) {
    case emailManagerConstants.VIEW_OVERVIEW_REQUEST:
      return {
        sending: true
      };
    case emailManagerConstants.VIEW_OVERVIEW_SUCCESS:
      return {
        ...state,
        sending: false,
        emailList: action.data
      };
    case emailManagerConstants.VIEW_OVERVIEW_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error
      }; 
    case emailManagerConstants.GET_COUNTRYCITY_REQUEST:
      return {
        sending: true
      };
    case emailManagerConstants.GET_COUNTRYCITY_SUCCESS:
      return {
        ...state,
        sending: false,
        cityList: action.data
      };
    case emailManagerConstants.GET_COUNTRYCITY_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error
      }; 
    case emailManagerConstants.POST_CREATEEMAIL_REQUEST:
      return {
        sending: true
      };
    case emailManagerConstants.POST_CREATEEMAIL_SUCCESS:
      return {
        ...state,
        sending: false,
        emailStatus: action.data
      };
    case emailManagerConstants.POST_CREATEEMAIL_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error
      }; 
    case emailManagerConstants.GET_DETAIL_REQUEST:
      return {
        sending: true
      };
    case emailManagerConstants.GET_DETAIL_SUCCESS:
      return {
        ...state,
        sending: false,
        emailData: action.data
      };
    case emailManagerConstants.GET_DETAIL_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error
      }; 
    case emailManagerConstants.EDIT_DETAIL_REQUEST:
      return {
        sending: true
      };
    case emailManagerConstants.EDIT_DETAIL_SUCCESS:
      return {
        ...state,
        sending: false,
        emailUpdateStatus: action.data
      };
    case emailManagerConstants.EDIT_DETAIL_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error
      }; 
     case emailManagerConstants.DELETE_DETAIL_REQUEST:
      return {
        sending: true
      };
    case emailManagerConstants.DELETE_DETAIL_SUCCESS:
      return {
        ...state,
        sending: false,
        deleteStatus: action.data
      };
    case emailManagerConstants.DELETE_DETAIL_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error
      }; 
    case emailManagerConstants.SEND_TESTMAIL_REQUEST:
      return {
        sending: true
      };
    case emailManagerConstants.SEND_TESTMAIL_SUCCESS:
      return {
        ...state,
        sending: false,
        testMailStatus: action.data
      };
    case emailManagerConstants.SEND_TESTMAIL_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error
      }; 
    case emailManagerConstants.GET_DEAL_REQUEST:
      return {
        sending: true
      };
    case emailManagerConstants.GET_DEAL_SUCCESS:
      return {
        ...state,
        sending: false,
        dealList: action.data
      };
    case emailManagerConstants.GET_DEAL_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error
      };
    case emailManagerConstants.GET_TEMPLATE_REQUEST:
      return {
        sending: true
      };
    case emailManagerConstants.GET_TEMPLATE_SUCCESS:
      return {
        ...state,
        sending: false,
        template: action.data
      };
    case emailManagerConstants.GET_TEMPLATE_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error
      };
    case emailManagerConstants.POST_EXPORT_REQUEST:
      return {
        sending: true
      };
    case emailManagerConstants.POST_EXPORT_SUCCESS:
      return {
        ...state,
        sending: false,
        exportStatus: action.data
      };
    case emailManagerConstants.POST_EXPORT_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error
      };
    case emailManagerConstants.POST_IMPORT_REQUEST:
      return {
        sending: true
      };
    case emailManagerConstants.POST_IMPORT_SUCCESS:
      return {
        ...state,
        sending: false,
        importStatus: action.data
      };
    case emailManagerConstants.POST_IMPORT_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error
      };
    case emailManagerConstants.GET_FILELIST_REQUEST:
      return {
        sending: true
      };
    case emailManagerConstants.GET_FILELIST_SUCCESS:
      return {
        ...state,
        sending: false,
        subscriberList: action.data
      };
    case emailManagerConstants.GET_FILELIST_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error
      };
    case emailManagerConstants.GET_DISABLE_REQUEST:
      return {
        sending: true
      };
    case emailManagerConstants.GET_DISABLE_SUCCESS:
      return {
        ...state,
        sending: false,
        disableStatus: action.data
      };
    case emailManagerConstants.GET_DISABLE_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error
      };
    case emailManagerConstants.GET_TOTAL_REQUEST:
      return {
        sending: true
      };
    case emailManagerConstants.GET_TOTAL_SUCCESS:
      return {
        ...state,
        sending: false,
        totalUsers: action.data
      };
    case emailManagerConstants.GET_TOTAL_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error
      };
    case emailManagerConstants.POST_NOTIFICATION_REQUEST:
      return {
        sending: true
      };
    case emailManagerConstants.POST_NOTIFICATION_SUCCESS:
      return {
        ...state,
        sending: false,
        notification: action.data
      };
    case emailManagerConstants.POST_NOTIFICATION_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error
      };
    case emailManagerConstants.GET_NOTIFICATION_REQUEST:
      return {
        sending: true
      };
    case emailManagerConstants.GET_NOTIFICATION_SUCCESS:
      return {
        ...state,
        sending: false,
        notDetail: action.data
      };
    case emailManagerConstants.GET_NOTIFICATION_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error
      };
    case emailManagerConstants.POST_VIEWSTATS_REQUEST:
      return {
        sending: true
      };
    case emailManagerConstants.POST_VIEWSTATS_SUCCESS:
      return {
        ...state,
        sending: false,
        status: action.data
      };
    case emailManagerConstants.POST_VIEWSTATS_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error
      };
    case emailManagerConstants.MARKET_REQUEST:
      return {
        sending: true
      };
    case emailManagerConstants.MARKET_SUCCESS:
      return {
        ...state,
        sending: false,
        marketResponse: action.data
      };
    case emailManagerConstants.MARKET_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error
      };
    case emailManagerConstants.LIST_MARKET_REQUEST:
      return {
        sending: true
      };
    case emailManagerConstants.LIST_MARKET_SUCCESS:
      return {
        ...state,
        sending: false,
        marketList: action.data
      };
    case emailManagerConstants.LIST_MARKET_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error
      }; 
    case emailManagerConstants.GET_MARKET_REQUEST:
      return {
        sending: true
      };
    case emailManagerConstants.GET_MARKET_SUCCESS:
      return {
        ...state,
        sending: false,
        marketDetail: action.data
      };
    case emailManagerConstants.GET_MARKET_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error
      };
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/emailManagerReducer.js